import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE } from '../constant'

export const testFetch = (params, second = 1) => {
  console.log('params, ', params)
  // eslint-disable-next-line promise/param-names
  return new Promise((res) => {
    setTimeout(() => { res('OK') }, second * 1000)
  })
}

// 用户-查询订单当前进度 @token_required POST /expertAppraisal/userCheckProcess
export const userCheckProcess = ({ orderNumber }) => {
  return request({
    url: `${SERVER_DOMAIN}/expertAppraisal/userCheckProcess`,
    data: { orderNumber },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSExpertAppraisalOrderUserCheckProcessRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSExpertAppraisalOrderUserCheckProcessResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.OFFLINE_IDENTIFY,
    TOKEN_REQUIRED: true
  })
}

// 用户-接受回收报价 @token_required POST /expertAppraisal/recycleAccept
export const recycleAccept = ({ orderNumber, isAccept }) => {
  return request({
    url: `${SERVER_DOMAIN}/expertAppraisal/recycleAccept`,
    data: { orderNumber, isAccept },
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSExpertAppraisalRecycleAcceptRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSExpertAppraisalRecycleAcceptResponse',
    ERROR_ACTION: 'toast',
    PROTO_MODULE: PROTO_MODULE.OFFLINE_IDENTIFY,
    TOKEN_REQUIRED: true
  })
}
